import { Route, Routes } from 'react-router-dom'

import CampaignStatement from './screens/CampaignStatement'
import ContributionsList from './screens/Contributions/screens/List'
import InvoiceEdit from './screens/Invoices/screens/Edit'
import InvoiceList from './screens/Invoices/screens/List'
import InvoicesImportList from './screens/InvoicesImport/screens/List'
import OrderReconciliation from './screens/OrderReconciliation'

const AccountingRoutes = () => (
  <Routes>
    <Route path="/campaignContributions" element={<ContributionsList />} />
    <Route path="/campaignStatement" element={<CampaignStatement />} />
    <Route path="/invoices" element={<InvoiceList />} />
    <Route path="/invoices/:invoiceId/edit/*" element={<InvoiceEdit />} />
    <Route path="/invoicesImport" element={<InvoicesImportList />} />
    <Route path="/orderReconciliation" element={<OrderReconciliation />} />
  </Routes>
)

export default AccountingRoutes
